import { ConstructionSiteAnalysisData } from "@dune/types";
import {
	Badge,
	Table,
	TableBody,
	TableCell,
	TableHead,
	TableHeader,
	TableRow,
} from "@dune/ui";
import { useConstructionSiteAnalysisData } from "../hooks/useConstructionSiteAnalysisData";
import { designerTypeLabels } from "../../../../../../../packages/vars/src";

interface DesignersControlTableProps {
	constructionSiteData: ConstructionSiteAnalysisData;
}

const StatusBadge = ({ status, label }: { status: boolean; label: string }) => {
	if (status) {
		return (
			<Badge className="bg-green-50 text-green-700 px-2 py-1 rounded-2xl text-xs font-medium">
				{label}
			</Badge>
		);
	}
	return (
		<Badge className="bg-red-50 text-red-700 px-2 py-1 rounded-2xl text-xs font-medium">
			Non
		</Badge>
	);
};

export const DesignersControlTable = ({
	constructionSiteData,
}: DesignersControlTableProps) => {
	const designersData = useConstructionSiteAnalysisData(constructionSiteData);

	return (
		<div className="bg-white rounded-xl shadow-[0px_1px_2px_0px_rgba(16,24,40,0.05)] border border-[#e9eaeb] w-full overflow-hidden">
			<Table>
				<TableHeader>
					<TableRow className="border-b border-[#e9eaeb] hover:bg-transparent">
						<TableHead className="text-[#535862] text-[10px] font-medium leading-4 h-11 px-4 py-3 w-[190px]">
							Type
						</TableHead>
						<TableHead className="text-[#535862] text-[10px] font-medium leading-4 h-11 px-4 py-3">
							Missions
						</TableHead>
						<TableHead className="text-[#535862] text-[10px] font-medium leading-4 h-11 px-4 py-3">
							Déclaré
						</TableHead>
						<TableHead className="text-[#535862] text-[10px] font-medium leading-4 h-11 px-4 py-3">
							Obligatoire
						</TableHead>
					</TableRow>
				</TableHeader>
				<TableBody>
					{designersData.map((designer, index) => (
						<TableRow
							key={`designer-${designer.type}-${index}`}
							className="border-b border-[#e9eaeb] hover:bg-gray-50/50"
						>
							<TableCell className="text-[#252b37] text-xs font-normal leading-4 h-14 px-4 py-3">
								{designerTypeLabels[designer.type]}
							</TableCell>
							<TableCell className="text-[#181d27] text-xs font-normal leading-4 h-14 px-4 py-3">
								{designer.missions}
							</TableCell>
							<TableCell className="h-14 px-4 py-3">
								<StatusBadge status={designer.declared} label="Oui" />
							</TableCell>
							<TableCell className="h-14 px-4 py-3">
								<StatusBadge status={designer.required} label="Oui" />
							</TableCell>
						</TableRow>
					))}
				</TableBody>
			</Table>
		</div>
	);
};
